import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-266f1956"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-categories-list" }
const _hoisted_2 = { class: "category__name" }
const _hoisted_3 = { class: "category__count" }

import FilterDropdown from './FilterDropdown.vue';
import FilterCheckbox from './FilterCheckbox.vue';
import { TStringFields } from '@/services';
import { parseCamelCase } from '@/utils';
import { useFilterByCategory } from '@/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterByCategory',
  props: {
    keyOfProduct: null
  },
  setup(__props: any) {

const props = __props as {
  keyOfProduct: keyof TStringFields;
};



const { categories, toggleCategory } = useFilterByCategory(props.keyOfProduct);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FilterDropdown, {
    title: _unref(parseCamelCase)(__props.keyOfProduct)
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (category) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "filter-categories-list__item",
            key: category.name
          }, [
            _createVNode(FilterCheckbox, {
              class: "category",
              "model-value": category.checked,
              "onUpdate:modelValue": ($event: any) => (_unref(toggleCategory)(category.name))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(category.name.trim()), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_3, "(" + _toDisplayString(category.count) + "/" + _toDisplayString(category.total) + ")", 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["model-value", "onUpdate:modelValue"])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title"]))
}
}

})